import http from '@utils/http';

const basePath = '/api';

export const login = async (body) => {
  const data = await http.post(`${basePath}/login`, body);

  return data.data;
};
